// src/icons/AppleLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function AppleLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 44,
    viewBox: "0 0 36 44",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M34.8503 15.0011C34.5938 15.1991 30.0656 17.7382 30.0656 23.3839C30.0656 29.9142 35.8275 32.2244 36 32.2816C35.9735 32.4224 35.0846 35.4455 32.962 38.5259C31.0694 41.2365 29.0927 43.9428 26.0857 43.9428C23.0787 43.9428 22.3049 42.2046 18.8336 42.2046C15.4507 42.2046 14.2479 44 11.4974 44C8.74684 44 6.82766 41.4917 4.62105 38.4114C2.0651 34.7943 0 29.1749 0 23.8416C0 15.2871 5.58949 10.7503 11.0905 10.7503C14.0135 10.7503 16.4501 12.6601 18.2852 12.6601C20.0319 12.6601 22.7559 10.6359 26.0813 10.6359C27.3416 10.6359 31.8698 10.7503 34.8503 15.0011ZM24.5026 7.0143C25.8779 5.39054 26.8508 3.13751 26.8508 0.884488C26.8508 0.572057 26.8242 0.255226 26.7667 0C24.5292 0.0836084 21.8671 1.48295 20.2619 3.33553C19.0016 4.76128 17.8253 7.0143 17.8253 9.29813C17.8253 9.64136 17.8828 9.9846 17.9093 10.0946C18.0509 10.121 18.2808 10.1518 18.5107 10.1518C20.5184 10.1518 23.0434 8.81408 24.5026 7.0143Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  AppleLogo
};
//# sourceMappingURL=AppleLogo.mjs.map